<div [ngClass]="{ 'alert-content--simple': !title }">
    <h4 class="alert-content__title" *ngIf="title">{{ title }}</h4>
    <div>
        <p class="alert-content__message" [innerHTML]="message"></p>
    </div>
</div>
